import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil, tap } from 'rxjs';
import { Subject } from 'rxjs';
import { SystemService, IUnread } from '../system/system.service';

@Component({
  selector: 'host-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.scss'],
})
export class ChannelComponent implements OnInit, OnDestroy {
  tab = 0;
  channelOfQueryParams;
  unreadCount = 0;

  private unreadChange$ = this.systemService.dotCountRaw$.pipe(
    tap((value) => {
      this.unreadCount = value.loseConnect;
    })
  );

  private destroy$ = new Subject();

  constructor(private activatedRoute: ActivatedRoute, public systemService: SystemService) {}

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((res) => {
      this.tab = Number(res.get('tab'));
      this.channelOfQueryParams = +res.get('channel');
    });
    this.unreadChange$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  // jumpToAnotherTab(res) {
  //   if (res) {
  //     this.tab = res.tab;
  //   }
  // }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
